function insideChatRootClass(isPageRoute) {
  if (isPageRoute) {
    return 'inside-chat-root inside-chat-root--page';
  }
  return 'inside-chat-root inside-chat-root--fill';
}

module.exports = { insideChatRootClass };
